import HttpError from '../../../utils/fetch/errors/HttpError';
import { packageName, packageVersion } from './package-context';
import { recentWorkClientExperienceV2, recentWorkClientExperienceV3 } from './index';
export async function fetchActivitiesWithExperience(fetchActivities, clientVersion) {
  const experience = clientVersion === 'v2' ? recentWorkClientExperienceV2() : recentWorkClientExperienceV3();
  try {
    experience.start();
    experience.addMetadata({
      clientVersion,
      packageName,
      packageVersion
    });
    const data = await fetchActivities(experience);
    experience.success();
    return data;
  } catch (e) {
    experience.failure({
      metadata: {
        error: exceptionToMetadata(e)
      }
    });
    throw e;
  }
}
export const exceptionToMetadata = e => {
  if (e instanceof HttpError) {
    var _e$xRequestId;
    return {
      ...e,
      xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
      cause: undefined
    };
  }
  return e instanceof Error ? {
    ...e,
    cause: undefined
  } : 'unknown';
};